












































import { FormBlock } from '@/app/components';
import { offlineRetentionOptions, otherFilesRetentionOptions } from '@/modules/asset/config/asset';
import { ContractStatus } from '@/modules/sharing/constants';
import { PropType, computed, defineComponent } from '@vue/composition-api';
import { Contract, ContractTransaction } from '../../types';
import LicenseDetail from './LicenseDetail.vue';

export default defineComponent({
    name: 'LicenseDetails',
    components: {
        FormBlock,
        LicenseDetail,
    },
    props: {
        contract: {
            type: Object as PropType<Contract>,
            required: true,
        },
        onEditMode: {
            type: Boolean,
            default: false,
        },
        previousNegotiation: {
            type: Object as PropType<ContractTransaction>,
            default: () => ({}),
        },
        isDerivation: {
            type: Boolean,
            default: false,
        },
        assetTypeId: {
            type: Number,
            default: 1,
        },
        hasUpdatingContract: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const checkboxOptions: any = computed(() =>
            props.contract?.asset?.structure?.type === 'other' ? otherFilesRetentionOptions : offlineRetentionOptions,
        );

        const offlineRetention = computed(() => {
            if (!props.contract.metadata.license.offlineRetention) return null;
            const options =
                props.contract?.asset?.structure?.type === 'other'
                    ? otherFilesRetentionOptions
                    : offlineRetentionOptions;
            const newValues = props.contract.metadata.license.offlineRetention;
            if (
                props.contract.status === ContractStatus.Negotiate &&
                props.previousNegotiation?.changes.metadata?.license?.offlineRetention
            ) {
                const oldValues = props.previousNegotiation.changes.metadata.license.offlineRetention;
                return { oldValues, newValues, options };
            }
            return { oldValues: null, newValues, options };
        });

        const offlineRetentionChanged = (item: string) => {
            const index = props.contract.metadata.license.offlineRetention.indexOf(item);
            if (index > -1) props.contract.metadata.license.offlineRetention.splice(index, 1);
            else props.contract.metadata.license.offlineRetention.push(item);
        };

        return {
            checkboxOptions,
            ContractStatus,
            offlineRetention,
            offlineRetentionChanged,
        };
    },
});
